import Button from './Button';
import { styled } from '@mui/system';
import colors from '../../assets/colors';
import { Add } from '@mui/icons-material';

const CustomButton = styled(Button)(({ theme }) => ({
  background: colors.oldAgroweGreen,
  color: colors.white,
  borderRadius: 20,
  p: 10,
  mr: 3,
  maxHeight: 50,
  '&:hover': {
    background: `${colors.oldAgroweGreen}99`,
  },
}));

export default function RoundedAddButton(props) {
  return (
    <CustomButton variant="contained" {...props}>
      <Add sx={{ mr: 2 }} />
      {props.children}
    </CustomButton>
  );
}
